import React, { lazy } from 'react';
import { Layout } from '../components/layout/Layout';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Button } from '../components/ui/Button';
import { MapPin, Phone, Mail, Clock, Send } from 'lucide-react';
import { motion } from 'framer-motion';
export function ContactPage() {
  return <Layout data-id="element-476">
      {/* Header */}
      <div className="bg-[#0A1F44] pt-44 md:pt-48 pb-20 text-center text-white relative overflow-hidden" data-id="element-477">
        <div className="absolute inset-0 opacity-40" data-id="element-478">
          <img src="https://images.unsplash.com/photo-1478147427282-58a87a120781?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Background" className="w-full h-full object-cover" data-id="element-479" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1F44]/80 via-[#0A1F44]/40 to-[#0A1F44]/80" data-id="element-480" />
        <div className="container-custom relative z-10" data-id="element-481">
          <h1 className="text-4xl md:text-6xl font-serif font-bold mb-4" data-id="element-482">
            Contact Us
          </h1>
          <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-483">
            We'd love to hear from you. Reach out with any questions or prayer
            requests.
          </p>
        </div>
      </div>

      <section className="py-20 bg-white" data-id="element-484">
        <div className="container-custom" data-id="element-485">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-486">
            {/* Contact Info */}
            <div data-id="element-487">
              <SectionHeading title="Get In Touch" subtitle="Reach Out" alignment="left" data-id="element-488" />
              <p className="text-gray-600 mb-10 text-lg" data-id="element-489">
                Whether you have a question about our ministries, need prayer,
                or want to know more about TheHousehold, our team is ready to
                connect with you.
              </p>

              <div className="space-y-8" data-id="element-490">
                <div className="flex items-start gap-6" data-id="element-491">
                  <div className="w-14 h-14 bg-[#F5F7FA] rounded-full flex items-center justify-center text-[#fc0719] shrink-0" data-id="element-492">
                    <MapPin className="w-6 h-6" data-id="element-493" />
                  </div>
                  <div data-id="element-494">
                    <h3 className="text-xl font-bold text-[#0A1F44] mb-2" data-id="element-495">
                      Visit Us
                    </h3>
                    <p className="text-gray-600" data-id="element-496">
                      1221 Caraway Ct, #1090
                      <br data-id="element-497" />
                      Largo, MD 20774
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-6" data-id="element-498">
                  <div className="w-14 h-14 bg-[#F5F7FA] rounded-full flex items-center justify-center text-[#fc0719] shrink-0" data-id="element-499">
                    <Phone className="w-6 h-6" data-id="element-500" />
                  </div>
                  <div data-id="element-501">
                    <h3 className="text-lg font-bold text-[#0A1F44] mb-1" data-id="element-502">
                      Phone
                    </h3>
                    <div className="flex flex-col" data-id="element-503">
                      <a href="tel:301-996-6907" className="hover:text-[#fc0719] transition-colors" data-id="element-504">
                        (301) 996-6907
                      </a>
                    </div>
                  </div>
                </div>

                <div className="flex items-start gap-6" data-id="element-505">
                  <div className="w-14 h-14 bg-[#F5F7FA] rounded-full flex items-center justify-center text-[#fc0719] shrink-0" data-id="element-506">
                    <Mail className="w-6 h-6" data-id="element-507" />
                  </div>
                  <div data-id="element-508">
                    <h3 className="text-lg font-bold text-[#0A1F44] mb-1" data-id="element-509">
                      Email
                    </h3>
                    <a href="mailto:info@householdchurch.org" className="hover:text-[#fc0719] transition-colors" data-id="element-510">
                      info@householdchurch.org
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-6" data-id="element-511">
                  <div className="w-14 h-14 bg-[#F5F7FA] rounded-full flex items-center justify-center text-[#fc0719] shrink-0" data-id="element-512">
                    <Clock className="w-6 h-6" data-id="element-513" />
                  </div>
                  <div data-id="element-514">
                    <h3 className="text-xl font-bold text-[#0A1F44] mb-2" data-id="element-515">
                      Service Times
                    </h3>
                    <p className="text-gray-600" data-id="element-516">
                      Sunday Worship: 10:00 AM
                      <br data-id="element-517" />
                      Impact Wednesday: 7:00 PM
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} className="bg-[#F5F7FA] p-8 md:p-12 rounded-2xl border border-[#fc0719]/10 shadow-sm" data-id="element-518">
              <h2 className="text-2xl font-serif font-bold text-[#0A1F44] mb-8" data-id="element-519">
                Send us a Message
              </h2>
              <form className="space-y-6" data-id="element-520">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-521">
                  <div data-id="element-522">
                    <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-523">
                      First Name
                    </label>
                    <input type="text" id="firstName" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#0A1F44] focus:border-transparent transition-all" placeholder="John" data-id="element-524" />
                  </div>
                  <div data-id="element-525">
                    <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-526">
                      Last Name
                    </label>
                    <input type="text" id="lastName" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#0A1F44] focus:border-transparent transition-all" placeholder="Doe" data-id="element-527" />
                  </div>
                </div>

                <div data-id="element-528">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-529">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#0A1F44] focus:border-transparent transition-all" placeholder="john@example.com" data-id="element-530" />
                </div>

                <div data-id="element-531">
                  <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-532">
                    Subject
                  </label>
                  <select id="subject" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#0A1F44] focus:border-transparent transition-all bg-white" data-id="element-533">
                    <option data-id="element-534">General Inquiry</option>
                    <option data-id="element-535">Prayer Request</option>
                    <option data-id="element-536">Join a Ministry</option>
                    <option data-id="element-537">Feedback</option>
                  </select>
                </div>

                <div data-id="element-538">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-539">
                    Message
                  </label>
                  <textarea id="message" rows={5} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#0A1F44] focus:border-transparent transition-all resize-none" placeholder="How can we help you?" data-id="element-540"></textarea>
                </div>

                <button type="submit" className="inline-flex items-center gap-2 bg-[#fc0719] hover:bg-[#d4061a] text-white font-bold text-sm px-5 py-3 rounded-lg shadow-lg transition-colors" data-id="element-541">
                  SEND MESSAGE
                  <Send className="w-4 h-4" data-id="element-542" />
                </button>
              </form>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="h-[500px] relative" data-id="element-543">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3107.5!2d-76.83!3d38.89!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7bf2e1b3e5c7d%3A0x0!2s1221+Caraway+Ct+%231090%2C+Largo%2C+MD+20774!5e0!3m2!1sen!2sus!4v1710000000000" className="absolute inset-0 w-full h-full border-0" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="TheHousehold Church Location" data-id="element-544" />
        <div className="absolute bottom-6 right-6 z-10" data-id="element-545">
          <a href="https://maps.google.com/?q=1221+Caraway+Ct+%231090+Largo+MD+20774" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[#fc0719] hover:bg-[#d4061a] text-white font-bold text-sm px-5 py-3 rounded-lg shadow-lg transition-colors" data-id="element-546">
            <MapPin className="w-4 h-4" data-id="element-547" /> Get Directions
          </a>
        </div>
      </section>
    </Layout>;
}